import * as url from './url_helper';
export const SyncConfiguration = async ({ payload }: any) => {
  const { pagination, filters } = payload;

  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }
  if (user.ROL_ID !== '19') {
    const clientId = user.EMPRESA_ID.toString();
    filters.dynamicFilter += ` , clientId: "${clientId}"`;
  }
  const queryPagination = `
    {
        sizePage: ${pagination?.sizePerPage || 0}, 
        actualPage: ${pagination?.page || 0}
    }`;

  const queryFilters = `
    {
        ${filters?.dynamicFilter || ''}
    }`;
  const query = `
            query {
                SyncConfiguration( order: "${filters.order}", filter:${queryFilters},Pagination: ${queryPagination}){
                    listData {
                        id
                        clientId
                        OperationType
                        WorkflowEnabled
                        SyncEnabled
                        createdAt
                    }
                    CountItems
                    filterItems {
                        text
                        dataField
                        showInFilters
                        data {
                            id
                            name
                        }
                    }
                }
            }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  if (user.ROL_ID !== '19') {
    const { filterItems } = response.data.SyncConfiguration;
    filterItems.forEach((item: any) => {
      if (item.dataField === 'clientId') {
        item.showInFilters = false;
      }
    });
  }
  return response.data.SyncConfiguration;
};

export const CreateSyncConfiguration = async (payload: any) => {
  const { clientId, OperationType, WorkflowEnabled, SyncEnabled } = payload;
  console.log(SyncEnabled);
  const query = `
        mutation {
            createSyncConfiguration(SyncConfiguration:{
                clientId: "${clientId}"
                OperationType: "${OperationType}"
                WorkflowEnabled: ${WorkflowEnabled || false}
                SyncEnabled: ${SyncEnabled || false}
            })  {
                    id
                    clientId
                    OperationType
                    WorkflowEnabled
                    SyncEnabled
                    createdAt
                }
        }
     `;
  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response;
};

export const UpdateSyncConfiguration = async (payload: any) => {
  const { id, clientId, OperationType, WorkflowEnabled, SyncEnabled } = payload;

  const query = `
        mutation {
            updateSyncConfiguration(SyncConfiguration:{
                id: ${id}
                clientId: "${clientId}"
                OperationType: "${OperationType}"
                WorkflowEnabled: ${WorkflowEnabled}
                SyncEnabled: ${SyncEnabled}
            })  {
                    id
                    clientId
                    OperationType
                    WorkflowEnabled
                    SyncEnabled
                    createdAt
                }
        }
     `;
  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response;
};
export const DeleteSyncConfiguration = async (payload: any) => {
  const { id } = payload;

  const query = `
        mutation {
            deleteSyncConfiguration(SyncConfiguration:{
                id: ${id}
            })
        }
     `;
  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response;
};
